export const categories = [
  {
    id: 'cat-001',
    name: '热血',
    slug: 'action',
    description: '激燃战斗、热血沸腾的韩国漫画，带你体验力量与正义的碰撞',
    count: 1280,
    icon: 'ri-fire-line',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%2C%20dynamic%20battle%20scene%20with%20energy%20effects%2C%20warrior%20characters%20in%20motion%2C%20warm%20orange%20red%20color%20palette%2C%20clean%20simple%20background%2C%20anime%20manhwa%20style%2C%20dramatic%20composition&width=800&height=600&seq=category-action&orientation=landscape',
  },
  {
    id: 'cat-002',
    name: '恋爱',
    slug: 'romance',
    description: '甜蜜浪漫、心动不已的韩国恋爱漫画，感受美好爱情故事',
    count: 2150,
    icon: 'ri-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%2C%20couple%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20gentle%20romantic%20atmosphere%2C%20clean%20simple%20composition%2C%20anime%20manhwa%20art%20style&width=800&height=600&seq=category-romance&orientation=landscape',
  },
  {
    id: 'cat-003',
    name: '奇幻',
    slug: 'fantasy',
    description: '异世界冒险、魔法与龙，探索无限想象力的韩国奇幻漫画',
    count: 1650,
    icon: 'ri-magic-line',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%2C%20magical%20world%20with%20floating%20islands%20and%20castles%2C%20wizard%20casting%20spells%2C%20dragon%20in%20background%2C%20vibrant%20purple%20and%20teal%20color%20palette%2C%20clean%20composition%2C%20anime%20manhwa%20style&width=800&height=600&seq=category-fantasy&orientation=landscape',
  },
  {
    id: 'cat-004',
    name: '悬疑',
    slug: 'mystery',
    description: '烧脑推理、惊险刺激的韩国悬疑漫画，挑战你的推理极限',
    count: 890,
    icon: 'ri-search-eye-line',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20illustration%2C%20detective%20looking%20at%20clues%20on%20a%20desk%2C%20magnifying%20glass%2C%20dark%20moody%20atmosphere%2C%20film%20noir%20lighting%20with%20shadows%2C%20sepia%20brown%20color%20palette%2C%20clean%20composition%2C%20anime%20manhwa%20style&width=800&height=600&seq=category-mystery&orientation=landscape',
  },
  {
    id: 'cat-005',
    name: '搞笑',
    slug: 'comedy',
    description: '轻松幽默、爆笑不断的韩国搞笑漫画，让你捧腹大笑',
    count: 760,
    icon: 'ri-emotion-laugh-line',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20illustration%2C%20funny%20characters%20with%20exaggerated%20expressions%2C%20bright%20colorful%20palette%2C%20playful%20and%20lighthearted%20atmosphere%2C%20clean%20simple%20composition%2C%20anime%20manhwa%20chibi%20art%20style&width=800&height=600&seq=category-comedy&orientation=landscape',
  },
  {
    id: 'cat-006',
    name: '日常',
    slug: 'slice-of-life',
    description: '温馨治愈、真实感人的韩国日常漫画，记录平凡中的美好',
    count: 540,
    icon: 'ri-sun-line',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20illustration%2C%20cozy%20room%20with%20warm%20sunlight%20through%20window%2C%20young%20people%20chatting%20and%20laughing%2C%20soft%20warm%20beige%20and%20cream%20palette%2C%20peaceful%20atmosphere%2C%20clean%20composition%2C%20anime%20manhwa%20style&width=800&height=600&seq=category-slice-of-life&orientation=landscape',
  },
];